import storage from '~/storage';
import { UserData } from '../types/Users';
import http from '~/http/services/pos';
import { ApiResponse } from '~/types/Api';
import { Resource } from '~/types/Permission';
import { useEffect, useState } from 'react';

type MeResponse = ApiResponse<UserData>;

export const fetchMe = () => {
  return http.get<MeResponse>('/api/v1/user/me');
};

const TOKEN_KEY = 'auth';

let _isLoggedIn: boolean | null = null;
let _token: string | null = null;
let _userData: UserData | null = null;

export const getToken = () => {
  return _token;
};

export const getUserData = async () => {
  if (_userData != null) return _userData;
  const { data, error } = await fetchMe();
  if (!error && data) {
    _userData = data;
    return data;
  }
  throw error;
};

export const saveLoginData = ({
  token,
  user: userData,
}: {
  token: string;
  user: UserData;
}) => {
  _token = token;
  _userData = userData;
  _isLoggedIn = true;

  storage.set(TOKEN_KEY, token);
};

export const checkIsLoggedIn = async () => {
  if (_isLoggedIn != null) return _isLoggedIn;
  try {
    const rawToken = storage.get(TOKEN_KEY, null);
    if (rawToken) {
      _token = rawToken;
      const { data: dataMe, error: errorMe } = await fetchMe();

      if (errorMe || !dataMe) {
        throw 'Error verifying login';
      }

      _isLoggedIn = true;
      _userData = dataMe;
    }
  } catch (_) {
    _isLoggedIn = false;
    _token = null;
    _userData = null;
  }
  return _isLoggedIn;
};

export const logout = () => {
  _isLoggedIn = false;
  _token = null;
  _userData = null;
  storage.clear();
  window.location.href = '/login';
};

export const useUserData = () => {
  const [user, setUser] = useState<UserData | null>(null);

  useEffect(() => {
    getUserData().then((data) => {
      setUser(data);
    });
  });
  return user;
};
